import { makeAutoObservable } from 'mobx'
import { Typography, type IDropdownItem } from 'shared/ui'
import { type IResponseHubSpotTeams } from 'entities/Clients/api/types'
import styles from 'pages/clients/ui/shared/TeamsSelectField/ui/styles.module.scss'

export class TeamsSelectFieldStore {
  private _teamsList: IDropdownItem[] = []
  private _selectedTeamIds: number[] = []

  constructor() {
    makeAutoObservable(this)
  }

  get teamsList() {
    return this._teamsList
  }

  get selectedTeamIds() {
    return this._selectedTeamIds
  }

  get selectedTeamsForApi() {
    return this._selectedTeamIds.map((id) => ({
      id,
      name: this._teamsList.find((team) => team.id === id)?.label || '',
    }))
  }

  get selectedItems() {
    const teamById = new Map(this._teamsList.map((team) => [team.id, team]))
    return this._selectedTeamIds
      .map((id) => teamById.get(id))
      .filter((team): team is IDropdownItem => team !== undefined)
  }

  setTeamsList = (items: IResponseHubSpotTeams[]) => {
    this._teamsList = items?.map((team) => ({
      id: team.id,
      label: team.name,
      labelContent: (
        <Typography
          variant={'body-md-regular'}
          ellipsis
          tag='div'
          ariaLabel={'HubSpotTeam'}
          tooltipProps={{ label: team.name, placement: 'top' }}
        >
          {team.name}
        </Typography>
      ),
      className: styles.teamChip,
    }))
  }

  setSelectedTeamIds = (ids: number[]) => {
    this._selectedTeamIds = ids
  }

  addTeam = (item: IDropdownItem) => {
    const id = Number(item.id)
    if (!this._selectedTeamIds.includes(id)) {
      this._selectedTeamIds = [...this._selectedTeamIds, id]
    }
  }

  removeTeam = (item: IDropdownItem) => {
    this._selectedTeamIds = this._selectedTeamIds.filter((id) => id !== item.id)
  }

  reset = () => {
    this._selectedTeamIds = []
  }
}
